const a = "_horizontalPadding_ayt6h_1", d = "_gridCards_ayt6h_20", t = {
  horizontalPadding: a,
  gridCards: d
};
export {
  t as default,
  d as gridCards,
  a as horizontalPadding
};
